var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRejectedImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_867_4238)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "#FFE2E1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.94328 39.8483H28.7666C29.1112 39.8483 29.3906 39.5582 29.3906 39.2004L29.3906 8.29615C29.3906 7.93832 29.1112 7.64826 28.7666 7.64826H5.94335C5.5987 7.64826 5.31932 7.93832 5.31932 8.29615L5.31932 39.2004C5.31925 39.5582 5.59869 39.8483 5.94328 39.8483Z",
    fill: "url(#paint0_linear_867_4238)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9493 37.7299C26.8394 37.7299 27.5609 37.0084 27.5609 36.1183V11.2723C27.5609 10.3823 26.8394 9.66078 25.9493 9.66078H8.51776C7.62775 9.66078 6.90625 10.3823 6.90625 11.2723L6.90625 36.1183C6.90625 37.0084 7.62775 37.7299 8.51776 37.7299H25.9493Z",
    fill: "url(#paint1_linear_867_4238)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6882 34.2994C15.8635 34.3016 15.0387 34.3035 14.2139 34.3048C13.949 34.3052 13.684 34.3055 13.4191 34.3057C13.2164 34.3058 12.9976 34.3403 12.8263 34.2143C12.6346 34.0733 12.5686 33.8741 12.5248 33.6547C12.4297 33.1795 11.7181 33.24 11.5877 33.6547C11.5299 33.8383 11.2384 34.3641 10.9837 34.3211C10.8488 34.2983 10.7898 34.0978 10.7399 33.9939C10.6428 33.7918 10.572 33.5776 10.5115 33.3629C10.2557 32.456 10.2046 31.509 10.0446 30.5849C9.95182 30.0491 9.1038 30.2006 9.09012 30.7094C9.04659 32.33 8.77149 33.9285 8.17246 35.4476C7.95017 36.0112 8.88928 36.255 9.10956 35.6964C9.34053 35.1107 9.52389 34.5109 9.66616 33.9023C9.74248 34.124 9.83351 34.3416 9.94462 34.5532C10.2284 35.0934 10.8072 35.4129 11.4264 35.1727C11.6474 35.0869 11.849 34.937 12.0206 34.7546C12.0449 34.7815 12.0693 34.8081 12.0948 34.8329C12.5661 35.2912 13.186 35.2421 13.8025 35.2414C14.7644 35.2402 15.7263 35.238 16.6883 35.2354C17.3135 35.2338 17.3147 34.2977 16.6882 34.2994V34.2994Z",
    fill: "#232D38"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_867_4238)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0972 40.982C23.4391 40.982 23.0081 39.8639 22.4359 39.6265C21.8427 39.3805 20.7494 39.8572 20.3023 39.4101C19.8552 38.963 20.3319 37.8697 20.0859 37.2766C19.8486 36.7043 18.7305 36.2734 18.7305 35.6153C18.7305 34.9572 19.8486 34.5263 20.0859 33.954C20.3319 33.3608 19.8552 32.2675 20.3023 31.8205C20.7494 31.3735 21.8427 31.8501 22.4358 31.6041C23.0081 31.3668 23.439 30.2487 24.0971 30.2487C24.7552 30.2487 25.1861 31.3668 25.7584 31.6041C26.3516 31.8501 27.4449 31.3735 27.892 31.8206C28.339 32.2676 27.8624 33.3609 28.1084 33.9541C28.3457 34.5263 29.4638 34.9572 29.4638 35.6154C29.4638 36.2734 28.3457 36.7043 28.1084 37.2766C27.8624 37.8698 28.339 38.9631 27.892 39.4102C27.4449 39.8572 26.3516 39.3805 25.7585 39.6265C25.1862 39.8639 24.7553 40.982 24.0972 40.982V40.982Z",
    fill: "url(#paint2_linear_867_4238)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.0974,
    cy: 35.6156,
    r: 2.68333,
    fill: "url(#paint3_linear_867_4238)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_867_4238",
    x: 16.5818,
    y: 30.2487,
    width: 15.0298,
    height: 17.71,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.14868
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.07434
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_867_4238"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_867_4238",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_867_4238",
    x1: 29.3906,
    y1: 39.8483,
    x2: 5.31931,
    y2: 39.8483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31FF45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46DA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_867_4238",
    x1: 6.90625,
    y1: 37.7299,
    x2: 27.5609,
    y2: 37.7299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6FFDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253059,
    stopColor: "#F6FFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0FFBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_867_4238",
    x1: 18.7305,
    y1: 30.2487,
    x2: 18.7305,
    y2: 40.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE14C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C336"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_867_4238",
    x1: 21.4141,
    y1: 32.9323,
    x2: 21.4141,
    y2: 38.2989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#14FF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFF00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_867_4238"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectedImg);
export default __webpack_public_path__ + "static/media/RejectedImg.b0b54a78455e78c6f0535f7bd9e54c70.svg";
export { ForwardRef as ReactComponent };